import { onMounted, onUnmounted } from 'vue';

const DISPLAY_CLASS = 'is-digital-display';

export function useDigitalDisplayChrome() {
  onMounted(() => {
    document.documentElement.classList.add(DISPLAY_CLASS);
    document.body.classList.add(DISPLAY_CLASS);
  });

  onUnmounted(() => {
    document.documentElement.classList.remove(DISPLAY_CLASS);
    document.body.classList.remove(DISPLAY_CLASS);
  });
}
